import { render, staticRenderFns } from "./WorkIconDemand.vue?vue&type=template&id=c672dc04"
import script from "./WorkIconDemand.vue?vue&type=script&lang=js"
export * from "./WorkIconDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports